<template>
  <div
    class="media__container media__container--centered media__container--pointer"
  >
    <div v-if="!isPlaying" @click="playVideo" ref="playContainer" class="media__poster">
      <img :src="props.poster" alt="Image" :width="props.width" :height="props.height" />
      <div class="media__button">
        <magnetic-button
          :testing=false
          buttonSize="100px"
          magnetPadding="120px"
          buttonText="View"
        ></magnetic-button>
      </div>
    </div>

    <div class="embed-container" v-if="isPlaying" :style="{ paddingBottom: props.padding + '%' }">
      <video width="320" height="240" controls autoplay>
        <source :src="props.file" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, onMounted, onBeforeUnmount } from 'vue';
import MagneticButton from '../components/MagneticButton.vue';

const props = defineProps({
  playing: Boolean,
  padding: Number,
  poster: String,
  width: Number,
  height: Number,
  file: String,
});

const isPlaying = ref(props.playing);

const playVideo = () => {
  isPlaying.value = true;
};

</script>